import {Sound} from '../../../shared/scripts/Sound'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {UICoinProductView} from '../../../shared/scripts/store/UICoinProductView'
import {DiscordInstance} from '../discord/DiscordInstance'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIDStoreBodyController} from './UIDStoreBodyController'

export class UIDCoinProductView extends UICoinProductView {
    protected override handleBuyButtonClicked() {
        Sound.playSound(Sound.SoundType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedPurchaseCoinDiscord, this.product.price)

        if(UIUtilsEjsVariables.isUserOnDiscordMobile) {
            UIDStoreBodyController.showUnavailableOnMobilePopup()
            return
        }

        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseCoins, this.product.type)
    }
}
